import { Icon } from '@kk/ui/components/Icon';
import { cn } from 'cn';
import { NavLink } from 'react-router-dom';
import type { SideNavigationLink } from '@/components/SideNavigation/SideNavigation';

type Props = {
  links?: SideNavigationLink[];
};

export const MenuContent = ({ links }: Props) => {
  return (
    <ul role="menu" className="text-blue-60 flex w-full flex-col gap-4">
      {links?.map((link, index) => (
        <li key={`item-${index}`}>
          <NavLink
            end
            title={link.title}
            to={link.disabled ? '#' : link.to}
            aria-disabled={link.disabled}
            className="typ-body block rounded aria-disabled:pointer-events-none"
            onClick={() => {
              document.querySelector('main')?.focus();
            }}
          >
            {({ isActive }) => (
              <div
                className={cn(
                  'flex size-full min-w-fit items-center justify-start rounded-md p-4 hover:cursor-pointer md:justify-start',
                  isActive
                    ? 'bg-blue-10 hover:bg-blue-20 text-blue-100'
                    : 'hover:bg-blue-10 bg-transparent',
                )}
              >
                <Icon type={link.icon} size="small" solid />
                <span
                  className={cn(
                    'h-full whitespace-nowrap pl-2 group-focus-within:inline-block group-hover:inline-block lg:hidden',
                    isActive ? 'text-blue-100' : 'text-blue-60',
                  )}
                >
                  {link.title}
                </span>
              </div>
            )}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
